// extracted by mini-css-extract-plugin
export default {"header":"_1vgE","container":"eH1y","list":"_1EDr","list_number":"_3Taf","instruction_content":"Jmdk","instruction":"_2Vmu","print_button_container":"qaZ2","print_button":"dPhM"};